import { initializeApp } from "firebase/app";
import { getAuth, initializeAuth, indexedDBLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyD_E1qn3Zd5usRfFZW8ce_Pqc0k-oNF2WQ",
  authDomain: "rbac-afe88.firebaseapp.com",
  projectId: "rbac-afe88",
  storageBucket: "rbac-afe88.firebasestorage.app",
  messagingSenderId: "26896414818",
  appId: "1:26896414818:web:860f7d403c0039e138b93b",
  measurementId: "G-MZTPQ3R7WT"
};

const app = initializeApp(firebaseConfig);

// Use IndexedDB persistence on native (Capacitor WebView) so auth
// survives app restarts. browserLocalPersistence is unreliable in WebView.
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

export const firestore = getFirestore(app);
